import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

/**
 * Gets onboarding namespace from the state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {OnboardingState} entities by type
 */
export const selectOnboarding = createKeySelector('onboarding');

/**
 * Gets number of completed onboarding pages from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {number} of completed onboarding pages
 */
export const getNumberCompletedOnboardingPages = createSelector(
  selectOnboarding,
  (onboarding): number => onboarding.completedPages.length
);

/**
 * Gets current onboarding page from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {string} name of current onboarding page
 */
export const getCurrentOnboardingPage = createSelector(
  selectOnboarding,
  (onboarding): string => onboarding.pagesQueue[0]
);

/**
 * Gets onboarding pagesQueue from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {Array} list of onboarding pagesQueue
 */
export const getOnboardingPagesQueue = createSelector(
  selectOnboarding,
  (onboarding): string[] => onboarding.pagesQueue
);

/**
 * Gets whether onboarding is open from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {boolean} true if onboarding is open
 */
export const getIsOnboardingOpen = createSelector(
  selectOnboarding,
  (onboarding): boolean => onboarding.onboardingOpen
);

/**
 * Gets whether onboarding is skipped from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {boolean} true if onboarding is skipped
 */
export const getIsOnboardingSkipped = createSelector(
  selectOnboarding,
  (onboarding): boolean => onboarding.didSkipOnboarding
);

/**
 * Gets whether swipe demo was shown from the top-level state
 *
 * @param  {GlobalStateType} state - top-level state
 * @return {boolean} true if swipe demo was shown
 */
export const getIsSwipeDemoShown = createSelector(
  selectOnboarding,
  (onboarding): boolean => onboarding.swipeDemoShown
);
